import { render, staticRenderFns } from "./MessageManagement.vue?vue&type=template&id=3a02acfc&scoped=true&"
import script from "./MessageManagement.vue?vue&type=script&lang=js&"
export * from "./MessageManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a02acfc",
  null
  
)

export default component.exports